// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { enableIndexedDbPersistence } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB3mCWWCeS2FN1B76i3enqsASd024-O0iY",
  authDomain: "awlone-test.firebaseapp.com",
  projectId: "awlone-test",
  storageBucket: "awlone-test.firebasestorage.app",
  messagingSenderId: "55187945383",
  appId: "1:55187945383:web:50e52e571db47967522882",
  measurementId: "G-CHXJ715748"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn("Persistence failed (maybe multiple tabs open)");
  } else if (err.code === 'unimplemented') {
    console.warn("Persistence is not available in this browser");
  }
});

export { db };